export default __webpack_public_path__ + "static/media/default-card.2b08be9e.png";